<template>
    <Header :isLoginPage="true" />
    <SignUp></SignUp>
    <Footer></Footer>
</template>

<script>
  import Header from '@/components/Header.vue'
  import SignUp from '@/components/user/SignUp.vue'
  import Footer from '@/components/Footer.vue'

import {mapGetters,mapActions} from 'vuex'
  export default {
    components: {
      Header,
        SignUp,
        Footer
    },
      computed: {
        ...mapGetters([
            'isMobile'
        ]),
    },
  }
</script>

